<template>
  <div v-if="dataModel!=null" class>
    <!-- header start -->
    <van-nav-bar
      title="赠送高级会员佣金明细"
      left-arrow
      fixed
      :z-index="99"
      @click-left="onClickLeft"
      :border="false"
    />
    <div class="navBarSpace"></div>
    <!-- header end -->

    <div class="commission-nav">
      <div class="item">
        <div class="tit">直推收入(元)</div>
        <div class="num">{{dataModel.TotalDirect}}</div>
      </div>
      <div class="line"></div>
      <div class="item" @click="catePopupShow = true">
        <div class="tit">间接收入(元)</div>
        <div class="num">{{dataModel.TotalIndirect}}</div>
      </div>
    </div>

    <van-tabs
      sticky
      offset-top="46"
      title-active-color="#333"
      title-inactive-color="#888"
      background="#f8f8f8"
      color="#c3c3c3"
      :border="false"
      line-height="2"
    >
      <van-tab :title="'直推收支明细('+dataModel.DirectCount+')'" >
        <commissionGiveDetails_list :TypeId="0" ></commissionGiveDetails_list>
      </van-tab>
      <van-tab :title="'间接收支明细('+dataModel.IndirectCount+')'" >
         <commissionGiveDetails_list :TypeId="1" ></commissionGiveDetails_list>
      </van-tab>
    </van-tabs>
  </div>
</template>

<script>
import commissionGiveDetails_list from "@/components/commissionGiveDetails_list";
export default {
  data() {
    return {
       dataModel:null,
    };
  },
  components: {
    commissionGiveDetails_list
  },
  mounted() {
    document
      .querySelector("body")
      .setAttribute("style", "background-color:#f2f2f2");
    this.init();
  },
  beforeDestroy() {
    document.querySelector("body").removeAttribute("style");
  },
  methods: {
    init() {
      var that = this;
      that.$store
        .dispatch({
          type: "GetDistributionCommissionSeniorDetailed"
        })
        .then(
          res => {
            that.dataModel = res.TotalDistributionSeniorCommission;
          },
          error => {}
        );
    },
    onClickLeft() {
      this.$router.go(-1);
    }
  }
};
</script>

<style scoped>
</style>
